import axios from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GetTeamsQueryKey } from '../queries';

export const deleteTeam = async (teamId: number) => {
  return axios.delete(`/api/teams/${teamId}`);
};

export const useDeleteTeamMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (teamId: number) => deleteTeam(teamId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetTeamsQueryKey],
      });
    },
  });
};
